import { render, staticRenderFns } from "./DriverOwnerOperatorFields.vue?vue&type=template&id=828c726a"
import script from "./DriverOwnerOperatorFields.vue?vue&type=script&lang=js"
export * from "./DriverOwnerOperatorFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports